import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { CompanySearchPage } from '../CompanySearch/CompanySearch';
import { AppDescribtionPage } from '../../AppDescribtion/AppDescribtion';
import { ServiceProvider } from '../../../providers/ServiceProvider';
import { ChartsPage } from '../Charts/Charts';
import { SessionProvider } from '../../../providers/SessionProvider';
import { LoginProvider } from '../../../providers/LoginProvider';
import { NeedOpotrunityPage } from '../NeedOpotrunity/NeedOpotrunity';
import { LoginPage } from '../../Login/Login';

/*
  Generated class for the AtlasHome page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-AtlasHome',
    templateUrl: 'AtlasHome.html'
})
export class AtlasHomePage {
    a_Sliders: any = [];
    constructor(public navCtrl: NavController, public navParams: NavParams, public serviceProvider: ServiceProvider,
        public sessionProvider: SessionProvider, public loginProvider: LoginProvider, public toastController: ToastController) {
        this.LoadSponsers();
    }
    LoadSponsers() {
        this.a_Sliders.splice(0, this.a_Sliders.length);
        this.serviceProvider.Get("ISPA_atSponsor", false).then((result) => {
            console.log(result);
            let sliders: any = result;
            let index:any = 0;
            while (index < sliders.length) {
                console.log(sliders.slice(index, index + 3));
                this.a_Sliders.push({
                    slides: sliders.slice(index, index + 3)
                });
                index += 3;
            }
            //let slide: any = [];
            //let sliderIndex = 0;
            //slide.splice(0, slide.length);
            //sliders.forEach((value, index) => {
            //    slide.push(value);
            //    sliderIndex++;
            //    console.log(sliderIndex);
            //    if (sliderIndex == 3) {
            //        sliderIndex = 0;
            //        this.a_Sliders.push({ slides: slide });
            //        slide.splice(0, slide.length);
            //    }
            //});
            console.log(this.a_Sliders);
        });
    }
    Supliers() {
        if (this.sessionProvider.getToken() == null) {
            this.navCtrl.push(LoginPage);
            //this.loginProvider.presentPrompt().then((result) => {
            //    this.Supliers();
            //});
            return;
        }
        this.navCtrl.push(CompanySearchPage, { isCompany: false });
    }
    Companys() {
        if (this.sessionProvider.getToken() == null) {
            this.navCtrl.push(LoginPage);
            //this.loginProvider.presentPrompt().then((result) => {
            //    this.Companys();
            //});
            return;
        }
        this.navCtrl.push(CompanySearchPage, { isCompany: true });
    }
    About() {
        this.navCtrl.push(AppDescribtionPage, { Title: "درباره اطلس ملی فولاد", Color: "blue", Text: "AtlasAbout.txt" });
    }
    NotCompleted() {
        const toast = this.toastController.create({
            message: 'این قسمت در دست تکمیل می باشد',
            duration: 2000
        });
        toast.present();
    }
    Reports() {
        if (this.sessionProvider.getToken() == null) {
            this.navCtrl.push(LoginPage);
            //this.loginProvider.presentPrompt().then((result) => {
            //    this.Reports();
            //});
            return;
        }
        this.navCtrl.push(ChartsPage);
    }
    NeedOportunity() {
        if (this.sessionProvider.getToken() == null) {
            this.navCtrl.push(LoginPage);
            //this.loginProvider.presentPrompt().then((result) => {
            //    this.Companys();
            //});
            return;
        }
        this.navCtrl.push(NeedOpotrunityPage, { isCompany: true });
    }
}



// WEBPACK FOOTER //
// ./src/pages/atlas/AtlasHome/AtlasHome.ts